import React, { useContext } from "react";
import {
  TOGGLE_BREAKDOWN,
  TOGGLE_MATERIALS,
  TOGGLE_PDF_TYPE,
  TOGGLE_DISCOUNTS,
  TOGGLE_VAT_BREAKDOWN,
  APPLY_QUOTE_NUMBER,
} from "../reducers/pdfReducer";
import { doc } from "firebase/firestore";
import { updatePrimary } from "../helperFunctions/primaryWrites";
import { jobsheetsRef } from "../firebase";
import { SettingsContext } from "../providers/SettingsProvider";
import { formatAddress } from "../helperFunctions/pdfFunctions";

function PdfToolbar(props) {
  let { pdf, dispatch, totalInvoiceCost, addressLine, vat } = props;
  const { currentQuoteNumber, incCurrentPrimaryNumber } = useContext(SettingsContext);

  const showApplyQuote =
    pdf.pdfType === "Quote" && !pdf.timesheet.refNumber && pdf.timesheet.primaryType === "jobsheet";

  function applyQuoteNumber() {
    // Change jobsheet refNumber to latest quote number and increment by one.

    updatePrimary(doc(jobsheetsRef, pdf.timesheet.uid), {
      refNumber: currentQuoteNumber,
    }).then(() => {
      incCurrentPrimaryNumber("quote");
    });

    dispatch({
      type: APPLY_QUOTE_NUMBER,
      payload: currentQuoteNumber,
    });
  }

  return (
    <div className="pdfToolBar">
      <div className="toolLine">
        <label>Invoice type</label>
        <div className="invoiceTypeOptions">
          <button
            onClick={() => {
              dispatch({
                type: TOGGLE_PDF_TYPE,
                // timesheet: pdf.timesheet,
                addressLine,
                amount: totalInvoiceCost,
              });
            }}
          >
            {pdf.pdfType}
          </button>

          {showApplyQuote && (
            <button onClick={applyQuoteNumber} className="addQuoteNumber">
              + Qte No
            </button>
          )}
        </div>
      </div>
      {/* <div className="toolLine">
            <label>Job Description</label>
            <button onClick={() => toggleJobDescriptions((state) => !state)}>
              {showJobDescriptions ? "Show" : "Hide"}
            </button>
          </div> */}
      <div className="toolLine">
        <label>Materials</label>
        <button onClick={() => dispatch({ type: TOGGLE_MATERIALS })}>
          {pdf.showMaterials ? "Hide" : "Show"}
        </button>
      </div>
      {/* Only allow breakdown if not in VAT mode */}
      {!vat && (
        <div className="toolLine">
          <label>Breakdown</label>
          <button onClick={() => dispatch({ type: TOGGLE_BREAKDOWN })}>
            {pdf.showBreakdown ? "Hide" : "Show"}
          </button>
        </div>
      )}
      {/* Only allow VAT breakdown if in VAT mode */}
      {vat && (
        <div className="toolLine">
          <label>VAT</label>
          <button onClick={() => dispatch({ type: TOGGLE_VAT_BREAKDOWN })}>
            {pdf.showVatBreakdown ? "Hide" : "Show"}
          </button>
        </div>
      )}
      <div className="toolLine">
        <label>Discounts</label>
        <button onClick={() => dispatch({ type: TOGGLE_DISCOUNTS })}>
          {pdf.showDiscounts ? "Hide" : "Show"}
        </button>
      </div>
    </div>
  );
}

export default PdfToolbar;
